import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective, BsModalRef } from 'ngx-bootstrap/modal';
import {BackendApiService} from '../services/backend-api.service';
import { BackendSocketService } from '../services/backend-socket.service';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import { CommonService } from '../services/common.service';
import _ from "lodash";
import { NgForm }   from '@angular/forms';
import { interval } from 'rxjs'; 
import * as $ from 'jquery';

@Component({
  selector: 'app-settlementold',
  templateUrl: './settlementold.component.html',
  styleUrls: ['./settlementold.component.scss']
})
export class SettlementoldComponent implements OnInit {

  endOrder:Boolean = false; 
  badlaOrderList = [];
  scriptFilter = [];
  filterBadla = [];
  overAllResult : any = 0;
  userId =  localStorage.getItem('userId');
  selectedBadla = "1";
  constructor(private route: ActivatedRoute,
    private router: Router,
    private backendApiService: BackendApiService,
    private backendSocketService: BackendSocketService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.getBadlaOrder();
    this.getPL()
  }

  getBadlaOrder(){
    let data = {
      "isOpen":false,
      "userId" : this.userId
    }
    this.backendApiService.getBadlaOrderOld(data).subscribe(response => {
      if(response.status == true){
        this.badlaOrderList = response.data;
        console.log('this.badlaOrderList++++++++++++',this.badlaOrderList);
        this.filterBadla = response.data;
        this.scriptFilter = _.uniqBy(this.badlaOrderList, 'badlRefId');
        this.badlaOrderList.forEach(element => {
          let comexSellPrice = (element['endComexType'] == "sell") ? Number(element['endComexPrice']) : Number(element['comexPrice']);
          let comexBuyPrice = (element['endComexType'] == "sell") ? Number(element['comexPrice']) : Number(element['endComexPrice']);
          let comexQty = Number(element['comexQty']);
          let comexLotSize = element['comexDetail'][0]['lot_size'] ? Number(element['comexDetail'][0]['lot_size']) : 1;
          let endDgcxPrice = Number(element['endDgcxPrice']);          
          let comexEqu = (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
          let comexResult = comexEqu  * 10000/endDgcxPrice;
          element.comexResult = comexResult.toFixed(2);          

          let mcxSellPrice = (element['endMcxType'] == "sell") ? Number(element['endMcxPrice']) : Number(element['mcxPrice']);
          let mcxBuyPrice = (element['endMcxType'] == "sell") ? Number(element['mcxPrice']) : Number(element['endMcxPrice']);
          let mcxQty = Number(element['mcxQty']);
          let mcxLotSize = Number(element['mcxDetail'][0]['lot_size']);
          let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
          element.mcxResult = mcxResult.toFixed(2);          

          let dgcxSellPrice = (element['endDgcxType'] == "sell") ? Number(element['endDgcxPrice']) : Number(element['dgcxPrice']);
          let dgcxBuyPrice = (element['endDgcxType'] == "sell") ? Number(element['dgcxPrice']) : Number(element['endDgcxPrice']);
          let dgcxQty = Number(element['dgcxQty']);
          let dgcxLotSize = Number(element['dgcxDetail'][0]['lot_size']);                    
          let dgcxEqu = (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
          let dgcxResult = dgcxEqu  * 10000/endDgcxPrice;
          element.dgcxResult = dgcxResult.toFixed(2); 
          let sum = comexResult + mcxResult + dgcxResult;
          element.totalResult = sum.toFixed(2);
        });
      }else{
        this.badlaOrderList = [];
      }
    })
  }

  getPL(){
    let data = {
      "isOpen":false,
      "userId":this.userId
    }
    this.backendApiService.getOrderPLOld(data).subscribe(response => {
      if(response.status == true){
        this.overAllResult = Number(response.data).toFixed(2);
      }
    })
  }


  searchBadlaScript(){
    if(this.selectedBadla){
      let badlaId = this.selectedBadla;
      if(badlaId !== "1"){
        this.filterBadla = _.filter(this.badlaOrderList, function (dt) {
          return dt.badlRefId == badlaId;
        })
      }else{
        this.filterBadla = this.badlaOrderList;
      }
      this.filterBadla.forEach(element => {
        let comexSellPrice = (element['endComexType'] == "sell") ? Number(element['endComexPrice']) : Number(element['comexPrice']);
        let comexBuyPrice = (element['endComexType'] == "sell") ? Number(element['comexPrice']) : Number(element['endComexPrice']);
        let comexQty = Number(element['comexQty']);
        let comexLotSize = Number(element['comexDetail'][0]['lot_size']);
        let endDgcxPrice = Number(element['endDgcxPrice']);
        let comexEqu = (comexSellPrice - comexBuyPrice) * comexQty * comexLotSize;
        let comexResult = comexEqu  * 10000/endDgcxPrice;
        element.comexResult = comexResult.toFixed(2);          

        let mcxSellPrice = (element['endMcxType'] == "sell") ? Number(element['endMcxPrice']) : Number(element['mcxPrice']);
        let mcxBuyPrice = (element['endMcxType'] == "sell") ? Number(element['mcxPrice']) : Number(element['endMcxPrice']);
        let mcxQty = Number(element['mcxQty']);
        let mcxLotSize = Number(element['mcxDetail'][0]['lot_size']);
        let mcxResult = (mcxSellPrice - mcxBuyPrice) * mcxQty * mcxLotSize;
        element.mcxResult = mcxResult.toFixed(2);          

        let dgcxSellPrice = (element['endDgcxType'] == "sell") ? Number(element['endDgcxPrice']) : Number(element['dgcxPrice']);
        let dgcxBuyPrice = (element['endDgcxType'] == "sell") ? Number(element['dgcxPrice']) : Number(element['endDgcxPrice']);
        let dgcxQty = Number(element['dgcxQty']);
        let dgcxLotSize = Number(element['dgcxDetail'][0]['lot_size']);                    
        let dgcxEqu = (dgcxSellPrice - dgcxBuyPrice) * dgcxQty * dgcxLotSize;
        let dgcxResult = dgcxEqu  * 10000/endDgcxPrice;
        element.dgcxResult = dgcxResult.toFixed(2); 
        let sum = comexResult + mcxResult + dgcxResult;
        element.totalResult = sum.toFixed(2);
      });
      let data = {
        "isOpen":false,
        "userId":this.userId,
        "badlRefId" : (badlaId !== "1")?badlaId:null
      }
      console.log('data++++++',data);
      this.backendApiService.getOrderPL(data).subscribe(response => {
        if(response.status == true){
          console.log('response.data+++++++',response.data);
          this.overAllResult = Number(response.data).toFixed(2);
        }
      })      
    }
  }

}
